import { useEffect, useRef } from 'react';
import playNotificationSound, { unlockNotificationSound } from 'utils/chat/playNotificationSound';
import { totalUnread } from 'utils/chat/mergeInboxThreads';

// Suena cuando el total de no leídos SUBE. Lo que ya estaba sin leer al conectarse es la
// línea base (no suena), y bajar (leer) tampoco. Con `muted` sigue contando para no sonar
// tarde al dejar de estarlo: se usa mientras el usuario está dentro de una conversación, que
// ya ve llegar los mensajes en vivo.
export default function useNewMessageSound(inbox, { muted = false } = {}) {
  const previous = useRef(null);

  useEffect(() => {
    unlockNotificationSound();
  }, []);

  useEffect(() => {
    if (inbox === null || inbox === undefined) {
      return;
    }

    const total = totalUnread(inbox);
    if (previous.current !== null && total > previous.current && !muted) {
      playNotificationSound();
    }
    previous.current = total;
  }, [inbox, muted]);
}
